<div class="card card-stats" [ngStyle]="showCardById && { cursor: 'pointer' }">
  <div class="card-body">
    <div class="row" (click)="routeToLink()">
      <div class="col">
        <h5 class="card-title text-uppercase text-muted mb-0">
          {{ cardHeadline }}
        </h5>
        <span class="h2 font-weight-bold mb-0"> {{ cardTitle }} </span>
      </div>
      <div *ngIf="imgSrc" class="col-auto">
        <div
          class="icon icon-shape bg-gradient-red text-white rounded-circle shadow"
        >
          <img class="img-card" [src]="imgSrc" alt="" srcset="" />
          <!-- <i class=" ni ni-active-40"> </i> -->
        </div>
      </div>
    </div>
    <p class="mt-3 mb-0 text-sm">
      <span *ngIf="statistics" class="text-success mr-2">
        <!-- <i class=" fa fa-arrow-up"> </i>  -->
        {{ statistics.split() ? statistics.split("T")[0] : statistics }}
      </span>
      <br />
      <span *ngIf="spanText" class="text-danger text-nowrap">
        {{ spanText.split() ? spanText.split("T")[0] : spanText }}
      </span>
      <span *ngIf="copyLinkButton">
        <input
          #val
          [value]="copyLinkButton"
          style="opacity: 0; display: block; height: 0px"
        />
        <button
          class="btn btn-secondary btn-sm"
          #pop="bs-popover"
          type="button"
          (click)="onCopyHandler(val, pop)"
          popover="copied"
        >
          copy link
        </button>
      </span>
      <span *ngIf="resultPath && !resultPath.includes('null')">
        <a
          class="btn btn-icon btn-secondary"
          type="button"
          [href]="resultPath"
          target="_blank"
        >
          <span class="btn-inner--icon">
            <i class="ni ni-cloud-download-95"> </i>
          </span>
          <span class="btn-inner--text"> Result </span>
        </a>
      </span>
    </p>
    <br />
    <div *ngIf="status">{{ status }} {{ testRequestPatientPhone }}</div>
    <div *ngIf="!uploadResult" class="row action-btns">
      <!-- <div class="col"></div> -->
      <div class="col btns-block">
        <p class="mt-3 mb-0 justify-self-end text-sm">
          <span *ngIf="tests" class="text-info mr-2" [routerLink]="[tests, id]">
            <!-- Add Tests -->
            <i class="ni ni-books" style="cursor: pointer" alt="add-test"></i>
          </span>
          <span *ngIf="editUrl" class="text-success mr-2">
            <i
              class="fas fa-edit"
              style="cursor: pointer"
              [routerLink]="[editUrl, id]"
            ></i>
          </span>
          <span *ngIf="!noDeletable && !editableOnly && !cityComponent && !areaComponent" class="text-danger mr-2">
            <i
              class="fa fa-trash"
              style="cursor: pointer"
              (click)="openNotificationModal(modalNotification)"
              aria-hidden="true"
            ></i>
          </span>
          <span *ngIf="homeVisitFeesUrl" class="text-danger mr-2">
            <i
              class="fa fa-shopping-bag"
              style="cursor: pointer"
              [routerLink]="[homeVisitFeesUrl, id]"
              aria-hidden="true"
            ></i>
          </span>
          <span
            *ngIf="!reactive && noDeletable && !editableOnly"
            class="text-danger mr-2"
          >
            <button
              class="btn btn-icon btn-success"
              type="button"
              (click)="openNotificationModal(reActivateNotification)"
            >
              <span class="btn-inner--icon">
                <i class="ni ni-check-bold"> </i>
              </span>
            </button>
            <!-- <i
              class="fa fa-trash"
              style="cursor: pointer"
              (click)="openNotificationModal(modalNotification)"
              aria-hidden="true"
            ></i> -->
          </span>
          <span
            *ngIf="!refund && noDeletable && !editableOnly"
            class="text-danger mr-2"
          >
            <button
              class="btn btn-icon btn-warning"
              type="button"
              (click)="openNotificationModal(refundNotification)"
            >
              <span class="btn-inner--icon">
                <i class="ni ni-money-coins"> </i>
              </span>
            </button>
            <!-- <i
              class="fa fa-trash"
              style="cursor: pointer"
              (click)="openNotificationModal(modalNotification)"
              aria-hidden="true"
            ></i> -->
          </span>
        </p>
      </div>
    </div>
    <div *ngIf="uploadResult" class="row action-btns">
      <div class="col-md-6"></div>
      <div class="col btns-block">
        <p class="mt-3 mb-0 justify-self-end text-sm">
          <span class="text-success mr-2">
            <i
              class="ni ni-cloud-upload-96"
              style="cursor: pointer"
              [routerLink]="[uploadResult, id]"
            ></i>
          </span>
        </p>
      </div>
    </div>
  </div>
</div>
<div class="col-md-4">
  <ng-template #modalNotification>
    <div class="modal-header">
      <h6 class="modal-title" id="modal-title-notification">
        Your attention is required
      </h6>
      <button
        aria-label="Close"
        class="close"
        data-dismiss="modal"
        type="button"
        (click)="notificationModal.hide()"
      >
        <span aria-hidden="true"> × </span>
      </button>
    </div>
    <div class="modal-body">
      <div class="py-3 text-center">
        <i class="ni ni-bell-55 ni-3x"> </i>
        <h4 class="heading mt-4">You should read this!</h4>
        <p>you are about to delete {{ cardTitle }}.</p>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-white" type="button" (click)="onDeleteSubmit()">
        Ok, Delete
      </button>
      <button
        class="btn btn-link text-white ml-auto"
        data-dismiss="modal"
        type="button"
        (click)="notificationModal.hide()"
      >
        Cancel
      </button>
    </div>
  </ng-template>
</div>
<div class="col-md-4">
  <ng-template #refundNotification>
    <div class="modal-header">
      <h6 class="modal-title" id="modal-title-notification">
        Your attention is required
      </h6>
      <button
        aria-label="Close"
        class="close"
        data-dismiss="modal"
        type="button"
        (click)="notificationModal.hide()"
      >
        <span aria-hidden="true"> × </span>
      </button>
    </div>
    <div class="modal-body">
      <div class="py-3 text-center">
        <i class="ni ni-bell-55 ni-3x"> </i>
        <h4 class="heading mt-4">You should read this!</h4>
        <p>you are about to REFUND this appointment.</p>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-white" type="button" (click)="onRefund()">
        Ok, Refund
      </button>
      <button
        class="btn btn-link text-white ml-auto"
        data-dismiss="modal"
        type="button"
        (click)="notificationModal.hide()"
      >
        Cancel
      </button>
    </div>
  </ng-template>
</div>
<div class="col-md-4">
  <ng-template #reActivateNotification>
    <div class="modal-header">
      <h6 class="modal-title" id="modal-title-notification">
        Your attention is required
      </h6>
      <button
        aria-label="Close"
        class="close"
        data-dismiss="modal"
        type="button"
        (click)="notificationModal.hide()"
      >
        <span aria-hidden="true"> × </span>
      </button>
    </div>
    <div class="modal-body">
      <div class="py-3 text-center">
        <i class="ni ni-bell-55 ni-3x"> </i>
        <h4 class="heading mt-4">You should read this!</h4>
        <p>you are about to REACTIVATE this appointment.</p>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-white" type="button" (click)="onReactivate()">
        Ok, Reactive
      </button>
      <button
        class="btn btn-link text-white ml-auto"
        data-dismiss="modal"
        type="button"
        (click)="notificationModal.hide()"
      >
        Cancel
      </button>
    </div>
  </ng-template>
</div>
